import { useManufacturerQualityTiers } from '@/api/quality-tiers'
import { ManufacturerRatingBadge } from '@/components/manufacturer-rating-badge'
import {
  MANUFACTURER_RATING_KINDS,
  type ManufacturerRatingKind,
  type ManufacturerRatingValue,
} from '@/lib/manufacturer-ratings'

const SHOWN = 3

/** The manufacturer's ratings at a glance in the page header; opens the Ratings tab (USA-1258, USA-1272). */
export function QualityTierSummary({
  manufacturerUuid,
  onOpen,
}: {
  manufacturerUuid: string
  onOpen: () => void
}) {
  const { data: rows } = useManufacturerQualityTiers(manufacturerUuid)
  const rated = (rows ?? []).filter((row) => MANUFACTURER_RATING_KINDS.some((rating) => row[rating]))
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1 text-sm">
      <span className="font-medium">Ratings</span>
      {rated.length ? (
        <span className="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-1">
          {rated.slice(0, SHOWN).map((row) => (
            <span key={row.taxonomy_node_id} className="inline-flex items-center gap-1">
              {row.path.at(-1)}
              {MANUFACTURER_RATING_KINDS.map((rating) => {
                const value = row[rating]
                return value ? (
                  <ManufacturerRatingBadge
                    key={rating}
                    rating={rating}
                    value={value as ManufacturerRatingValue[ManufacturerRatingKind]}
                  />
                ) : null
              })}
            </span>
          ))}
          {rated.length > SHOWN && (
            <span className="text-muted-foreground">+{rated.length - SHOWN}</span>
          )}
        </span>
      ) : (
        <span className="text-muted-foreground">Not rated</span>
      )}
      <button
        type="button"
        onClick={onOpen}
        className="rounded underline underline-offset-2 hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50"
      >
        {rated.length ? 'Edit' : 'Set ratings'}
      </button>
    </div>
  )
}
